import React, { useState } from 'react';


import {
  StdInputText,
  BoxInput,
  LabelInput,
  
  TextWarning,
  Texto,
 
  Legend,
  TextInput,
  StdVisible,
  BtVisible,
  CounterInput
  } from './styles';
import { 
  StdRequired,
  BoxError,
  Error,
} from '../defaultStyles';

const InputText = ({
  name,
  placeholder,
  typeTxt,
  error,
  legend,
  onChange,
  value,  
  warningText,
  disabled,
  onFocus,
  required,
  maxCaracter = 30,
}) => {

 

  const [visible, setVisible] = useState(false);
  const toggleVisible = () => setVisible(v => !v);
  
  const effectiveType =
    visible && typeTxt === 'password' ? 'text' : typeTxt;
  return (
    <>
      <StdInputText>
        <LabelInput>
          <Legend className="legend">{legend}
          
          </Legend>
          {required && (           
           <StdRequired />   
          )}
          <BoxInput>
            <TextInput
              className={error ? 'warn' : 'neutral'}
              autoComplete="off"
              type={effectiveType}
              onChange={onChange}
              value={value}
              placeholder={placeholder}
              name={name}
              onFocus={onFocus}
              disabled={disabled}
              maxLength={maxCaracter}
            />
            {typeTxt === 'password' &&
              <StdVisible>
                <BtVisible onClick={toggleVisible}>
                  {!visible ? (
                    <svg
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="currentColor">
                      <path d="M12 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0-1.33A4.33 4.33 0 1 1 7.67 12 4.33 4.33 0 0 1 12 7.67zm0-.99a12.148 12.148 0 0 0-9.71 4.744l-.254.313L1.83 12l.205.264A12.874 12.874 0 0 0 12 17.319a12.234 12.234 0 0 0 9.71-4.743l.255-.312.204-.264-.204-.264A12.782 12.782 0 0 0 12 6.681zm0-1.33c4.654 0 8.517 2.103 11.538 6.26a.665.665 0 0 1 0 .78c-3.02 4.157-6.884 6.26-11.538 6.26S3.483 16.546.462 12.39a.665.665 0 0 1 0-.78C3.482 7.452 7.346 5.35 12 5.35z"></path>
                    </svg>
                  ) : (
                    <svg
                      role="img"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor">
                      <path d="M12 9.231a2.993 2.993 0 0 0-1.095.206l3.889 3.89A3.002 3.002 0 0 0 12 9.23zm0-2.319a12.523 12.523 0 0 0-3.216.404L9.906 8.44a4.331 4.331 0 0 1 5.886 5.884l1.864 1.866a13.572 13.572 0 0 0 4.008-3.327l.3-.368.205-.264-.204-.263a12.284 12.284 0 0 0-9.229-5.036l-.366-.015zm-3.912 3.461 1.028 1.03a3.002 3.002 0 0 0 3.714 3.712l1.027 1.029a4.332 4.332 0 0 1-5.77-5.77zM5.14 7.426l.975.972a13.707 13.707 0 0 0-3.783 3.207l-.296.363-.206.263.206.264a12.284 12.284 0 0 0 9.228 5.036l.367.014.369.005a12.63 12.63 0 0 0 2.93-.333l1.085 1.084A13.705 13.705 0 0 1 12 18.88c-4.654 0-8.517-2.102-11.538-6.258a.665.665 0 0 1 0-.782A15.988 15.988 0 0 1 5.14 7.426zm15.172 13.29L3.815 4.22l.936-.936 2.963 2.962A13.62 13.62 0 0 1 12 5.582c4.654 0 8.517 2.102 11.538 6.258a.665.665 0 0 1 0 .782 15.84 15.84 0 0 1-4.902 4.546l2.611 2.612z"></path>
                    </svg>
                  )}
                </BtVisible>

              </StdVisible>
            }
          </BoxInput>
          {warningText && (
            <TextWarning>
              <Texto>{warningText}</Texto>
            </TextWarning>
          )}
          {error && (
            <BoxError>
              <Error>
                <p className="err">{error}</p>
              </Error>
            </BoxError>
          )}
          {maxCaracter  && (
            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
              <CounterInput>{value.length}/{maxCaracter}</CounterInput>
            </div>
          )}
           
          
        </LabelInput>
      </StdInputText>
    </>
  );
};
export default InputText;
